import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TimeFilter } from "enums/transaction";
import { ApplicationRootState } from "types";
import { MemberOrderStateType } from "types/orders";

import { extraReducers } from "./orders.extraReducers";

export const initialState: MemberOrderStateType = {
  memberOrders: {
    deposit: {
      data: null,
      total: 0,
      isLoading: false,
      page: 1,
      pageSize: 5,
    },
    withdrawal: {
      data: null,
      total: 0,
      isLoading: false,
      page: 1,
      pageSize: 5,
    },
    rebate: {
      data: null,
      total: 0,
      isLoading: false,
    },
    filter: TimeFilter.TODAY,
  },
  memberPromotions: {
    data: null,
    total: 0,
    isLoading: false,
  },
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    updateCurrentPageDeposit(
      state: MemberOrderStateType,
      { payload }: PayloadAction<number>,
    ) {
      state.memberOrders.deposit.page = payload;
    },
    updateCurrentPageWithdrawal(
      state: MemberOrderStateType,
      { payload }: PayloadAction<number>,
    ) {
      state.memberOrders.withdrawal.page = payload;
    },
    resetDepositOrders(state: MemberOrderStateType) {
      state.memberOrders.deposit.total = 0;
      state.memberOrders.deposit.page = 1;
      state.memberOrders.deposit.data = null;
    },
    resetWithdrawalOrders(state: MemberOrderStateType) {
      state.memberOrders.withdrawal.total = 0;
      state.memberOrders.withdrawal.page = 1;
      state.memberOrders.withdrawal.data = null;
    },
    resetRebateOrders(state: MemberOrderStateType) {
      state.memberOrders.rebate.data = null;
    },
    updateOrdersFilter(
      state: MemberOrderStateType,
      { payload }: PayloadAction<TimeFilter>,
    ) {
      state.memberOrders.filter = payload;
    },
    resetOrders: () => initialState,
  },
  extraReducers,
});

export const selectMemberOrder = (state: ApplicationRootState) =>
  state.orders.memberOrders;

export const selectDepositOrders = (state: ApplicationRootState) =>
  state.orders.memberOrders.deposit;

export const selectWithdrawalOrders = (state: ApplicationRootState) =>
  state.orders.memberOrders.withdrawal;

export const selectRebateOrders = (state: ApplicationRootState) =>
  state.orders.memberOrders.rebate;

export const selectMemberPromotions = (state: ApplicationRootState) =>
  state.orders.memberPromotions;

export const selectTotalCountTransaction = (state: ApplicationRootState) =>
  state.orders.memberOrders.deposit.total;

export const selectIsLoadingTransaction = (state: ApplicationRootState) =>
  state.orders.memberOrders.deposit.isLoading;

export const selectOrdersFilter = (state: ApplicationRootState) =>
  state.orders.memberOrders.filter;

export const {
  updateCurrentPageDeposit,
  updateCurrentPageWithdrawal,
  resetDepositOrders,
  resetWithdrawalOrders,
  resetOrders,
  resetRebateOrders,
  updateOrdersFilter,
} = ordersSlice.actions;

export default ordersSlice.reducer;
